// references WP API REST
export const WEB_ROOT_ADDR = "https://www.bop-lepuy.fr";
export const WEB_ROOT_URL = WEB_ROOT_ADDR + "/";
export const WP_ROOT_ADDR =  WEB_ROOT_URL + 'wp-root';
export const WP_ROOT_URL =  WP_ROOT_ADDR + '/';

export const WP_API_ROOT = WP_ROOT_URL + "wp-json";
export const WP_API_ROOT_URL = WP_API_ROOT + "/";

export const WP_API_WP_ROOT = WP_API_ROOT_URL + "wp/v2";
export const WP_API_WP_ROOT_URL = WP_API_WP_ROOT + "/";
export const WP_API_ACF_ROOT = WP_API_ROOT_URL + "acf/v3";
export const WP_API_ACF_ROOT_URL = WP_API_ACF_ROOT + "/";

export const WP_API_JWT_ROOT = WP_API_ROOT_URL + "jwt-auth/v1/token";
export const WP_API_JWT_ROOT_URL = WP_API_JWT_ROOT + "/";
export const WP_API_JWT_VALIDATE_ROOT = WP_API_JWT_ROOT_URL + "validate";
export const WP_API_JWT_VALIDATE_ROOT_URL = WP_API_JWT_VALIDATE_ROOT + "/";

export const WEBSITE_ROOT_URL = "http://localhost:8051/"

// Index d'accès aux pages
export const RestPageIdx = {
    accueil : 235,
    actus : 239,
    agenda : 255,
    boutique : 266,
    boutique_en_construction : 1563,
    club : 237,
    comite : 1146,
    equipe_technique : 1151,
    gymnases : 1153,
    inscription : 1174,
    ressources : 1156,
    cgv : 208,
    contact : 268,
    equipes : 241,
    equipe : 243,
    galeries : 1103,
    galerie : 1119,
    mentions_legales : 202,
    mini_basket : 245,
    baby_basket : 249,
    obe : 247,
    nos_partenaires : 261,
    devenir_partenanire : 531,
    mecenat_dons : 264,
    page_exemple : 2,
    plan_site : 210,
    politique_confidentialite : 3,
    politique_cookies : 206,
    rgpd : 204,
    recherche : 270,
    search : 11,
    sport_sante : 251,
    sport_ordonnance : 253,
    basket_sante : 259,
    shared_content : 1136
}

export const RestCustomPosts =  { // custompost
    activites : {
        rest_name : "bop_activities",
        name : "bop_activities",
        taxo : {
            category: {
                rest_name :"category" ,
                name : "category"
            },
            tag : {
                rest_name :"post_tag" ,
                name : "post_tag"
            }
        }
    },
    agenda : {
        rest_name : "bop-agenda",
        name : "bop_agenda",
        taxo : {
            category: {
                rest_name :"bop_event_category" ,
                name : "bop_event_category"
            },
            tag : {
                rest_name :"bop_event_label" ,
                name : "bop_event_label"
            }
        }
    },
    carnet_adresses : {
        rest_name : "bop_adresses",
        name : "bop_adresses"
    },
    acces_contact : {
        rest_name : "bop_in_place",
        name : "bop_in_place"
    },
    sponsors : {
        rest_name : "bop_sponsors",
        name : "bop_sponsors",
        taxo : {
            category: {
                rest_name :"sponsor_categorie" ,
                name : "sponsor_categorie"
            }
        }
    },
    galeries : {
        rest_name : "bop_galeries",
        name : "bop_galeries"
    },
    obe_partenaires : {
        rest_name : "bop_obe_shared",
        name : "bop_obe_shared"
    },
    shop_articles : {
        rest_name : "bop_shop_items",
        name : "bop_boutique"
    },
    contenus_shared : {
        rest_name : "bop_shared_content",
        name : "bop_shared_content"
    },
    bop_members : {
        rest_name : "bop-members",
        name : "bop_members",
        taxo : {
            group: {
                rest_name :"membre_group" ,
                name : "membre_group"
            }
        }
    },
    equipes : {
        rest_name : "bop-equipes",
        name : "bop_equipes",
        taxo : {
            category: {
                rest_name :"equipes_categorie" ,
                name : "equipes_categorie"
            },
            group : {
                rest_name :"groupement_equipes" ,
                name : "groupement_equipes"
            },
            championnat : {
                rest_name :"equipes_championnat" ,
                name : "equipes_championnat"
            },
        }
    },
    salles_lieux : {
        rest_name : "bop_salles",
        name : "bop_salles"
    },
    ressources : {
        rest_name : "bop_ressources",
        name : "bop_ressources",
        taxo : {
          category: {
              rest_name :"resource_category" ,
              name : "resource_category"
          }
      }
    },
    liens : {
        rest_name : "bop_liens",
        name : "bop_liens"
    },
    note : {
        rest_name : "bop_notepad",
        name : "bop_notepad"
    }
    // woo commerce à mettre
}



// WEBPACK FOOTER //
// ./src/helpers/rest-api-addr.js